import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-yarbo-charcoal text-white pt-16 pb-8" data-id="element-26">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-28">
          {/* Brand Col */}
          <div data-id="element-29">
            <Link to="/" className="flex flex-col mb-6" data-id="element-30">
              <span className="text-2xl font-extrabold tracking-tight text-white leading-none" data-id="element-31">
                Yarbo Michigan
              </span>
              <span className="text-sm font-medium text-gray-400 tracking-wide mt-1" data-id="element-32">
                by Merem Robotics
              </span>
            </Link>
            <p className="text-gray-400 text-sm mb-6 leading-relaxed" data-id="element-33">
              Your premium local Michigan source for Yarbo robotic yard-care
              products. We provide sales, setup guidance, and support for
              Michigan homeowners.
            </p>
            <div className="space-y-3" data-id="element-34">
              <div className="flex items-start text-gray-300 text-sm" data-id="element-35">
                <MapPin className="w-5 h-5 mr-3 text-yarbo-yellow flex-shrink-0" data-id="element-36" />
                <span data-id="element-37">[Address or Michigan Service Area]</span>
              </div>
              <div className="flex items-center text-gray-300 text-sm" data-id="element-38">
                <Phone className="w-5 h-5 mr-3 text-yarbo-yellow flex-shrink-0" data-id="element-39" />
                <span data-id="element-40">[Phone]</span>
              </div>
              <div className="flex items-center text-gray-300 text-sm" data-id="element-41">
                <Mail className="w-5 h-5 mr-3 text-yarbo-yellow flex-shrink-0" data-id="element-42" />
                <span data-id="element-43">[Email]</span>
              </div>
            </div>
          </div>

          {/* Shop Col */}
          <div data-id="element-44">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-45">Shop Yarbo</h4>
            <ul className="space-y-3" data-id="element-46">
              <li data-id="element-47">
                <Link to="/shop" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-48">
                  All Products
                </Link>
              </li>
              <li data-id="element-49">
                <Link to="/category/lawn-mowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-50">
                  Lawn Mowers
                </Link>
              </li>
              <li data-id="element-51">
                <Link to="/category/snow-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-52">
                  Snow Blowers
                </Link>
              </li>
              <li data-id="element-53">
                <Link to="/category/leaf-blowers" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-54">
                  Leaf Blowers
                </Link>
              </li>
              <li data-id="element-55">
                <Link to="/category/bundles" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-56">
                  All-Season Bundles
                </Link>
              </li>
              <li data-id="element-57">
                <Link to="/category/modules-accessories" className="text-gray-400 hover:text-yarbo-yellow transition-colors text-sm" data-id="element-58">
                  Modules & Accessories
                </Link>
              </li>
            </ul>
          </div>

          {/* Support Col */}
          <div data-id="element-59">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-60">
              Support & Info
            </h4>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <Link to="/installation-demos" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-63">
                  Installation & Demos
                </Link>
              </li>
              <li data-id="element-64">
                <Link to="/faq" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-65">
                  Michigan FAQ
                </Link>
              </li>
              <li data-id="element-66">
                <Link to="/guides" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-67">
                  Buying Guides
                </Link>
              </li>
              <li data-id="element-68">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-69">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-70">
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-sm" data-id="element-71">
                  Request a Quote
                </Link>
              </li>
            </ul>
          </div>

          {/* CTA Col */}
          <div data-id="element-72">
            <h4 className="text-lg font-bold mb-6 text-white" data-id="element-73">
              Ready for Automation?
            </h4>
            <p className="text-gray-400 text-sm mb-6" data-id="element-74">
              Stop spending your weekends mowing and shoveling. Let's find the
              right Yarbo system for your property.
            </p>
            <Link to="/contact" className="btn-primary w-full justify-center mb-4" data-id="element-75">
              Get a Michigan Quote
            </Link>
            <Link to="/installation-demos" className="btn-secondary w-full justify-center bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500" data-id="element-76">
              Schedule a Demo
            </Link>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 mt-8 text-center md:text-left flex flex-col md:flex-row justify-between items-center" data-id="element-77">
          <p className="text-gray-500 text-xs mb-4 md:mb-0" data-id="element-78">
            &copy; {new Date().getFullYear()} Merem Robotics. All rights
            reserved.
          </p>
          <p className="text-gray-500 text-xs max-w-2xl text-center md:text-right" data-id="element-79">
            Yarbo products sold by Merem Robotics. Yarbo trademarks and product
            names belong to their respective owner. This is a local Michigan
            retailer website.
          </p>
        </div>
      </div>
    </footer>;
}